import { useState } from 'react';
import DataTable from 'react-data-table-component';
import Format from '../../../Services/Format';
import Globals from '../../../Globals.json';
import LayoutFilter from '../../data/LayoutFilter';
import LayoutTable from '../../data/LayoutTable';
import ModalBootstrap from '../../data/Modal';
import { Btn } from '../../data/Btn';
import tableStyleDefault from '../../../Services/tableStyleDefault';
import CustomLoader from '../../data/customLoader';
import { useAppSelector } from '../../../redux/store';
import { useQueryFetchPages } from '../../../apiQuery/useQueryFetchPages';
import { useDeleteData } from '../../../apiQuery/useDeleteData';
import { showSuccess } from '../../../apiQuery/toast';

export default function ListaVendasTemporarias() {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);

  const [page, setPage] = useState(1);
  const [modalDeleteAll, setModalDeleteAll] = useState(false);

  const {
    data: vendasTemporarias,
    isLoading: isLoadingVendasTemporarias,
  } = useQueryFetchPages<any>(
    ['sales-temporary'],
    `${Globals.api.salesTemporary}`,
    {
      page,
      queryParams: {
        store_id: storeMe?.storeActive?.id,
      },
    }
  );

  const deleteAll = useDeleteData(['sales-temporary']);

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setPage(page);
  };

  const handleDeleteAll = () => {
    deleteAll.mutate(
      {
        endpoint: Globals.api.salesTemporary,
        id: storeMe?.storeActive?.id,
      },
      {
        onSuccess: (data: any) => {
          setModalDeleteAll(false);
          showSuccess(
            data?.message ?? 'Vendas temporárias removidas com sucesso.'
          );
          setPage(1);
        },
      }
    );
  };

  const columns = [
    {
      name: 'Número',
      center: true,
      grow: 0.3,
      selector: (row: any) => row.number,
    },
    {
      name: 'Terminal',
      center: true,
      grow: 0.3,
      selector: (row: any) => row.terminal,
    },
    {
      name: 'Turno',
      center: true,
      grow: 0.3,
      selector: (row: any) => (row.shift ? 'turno ' + row.shift : ''),
    },
    {
      name: 'Data de Criação',
      center: true,
      grow: 0.5,
      selector: (row: any) =>
        row.created_at
          ? Format.date(new Date(row.created_at), 'DD/MM/YYYY HH:mm:ss')
          : '',
    },
    {
      name: 'Quantidade',
      center: true,
      grow: 0.3,
      selector: (row: any) => row.sale_qty,
    },
    {
      name: 'Valor Unitário',
      center: true,
      grow: 0.3,
      selector: (row: any) => Format.formatCurrencyBr(row.unit_sale_value),
    },
    {
      name: 'Total',
      center: true,
      grow: 0.3,
      selector: (row: any) => Format.formatCurrencyBr(row.total),
    },
    {
      name: 'Cancelada',
      center: true,
      grow: 0.3,
      selector: (row: any) => (row.canceled ? 'Sim' : 'Não'),
    },
  ];

  return (
    <>
      <ModalBootstrap
        state={modalDeleteAll}
        setState={setModalDeleteAll}
        text="Tem certeza de que deseja excluir todas as vendas temporárias desta loja? Esta ação não pode ser desfeita."
        handleAction={handleDeleteAll}
      />

      <LayoutFilter
        title="Vendas Temporárias"
        extraActions={
          <Btn
            text="Excluir Todas"
            type="button"
            variante="danger"
            icon="trash"
            onClick={() => setModalDeleteAll(true)}
            disable={deleteAll.isPending || !vendasTemporarias?.data?.length}
          />
        }
      >
        <></>
      </LayoutFilter>

      <LayoutTable>
        <DataTable
          columns={columns}
          data={vendasTemporarias?.data ?? []}
          striped
          pagination
          paginationServer
          paginationTotalRows={vendasTemporarias?.meta?.total}
          paginationDefaultPage={1}
          paginationPerPage={15}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          customStyles={tableStyleDefault}
          paginationComponentOptions={{
            rowsPerPageText: 'Registros por página',
            rangeSeparatorText: 'de',
          }}
          progressPending={isLoadingVendasTemporarias}
          progressComponent={<CustomLoader />}
          noDataComponent="Nenhuma informação foi encontrada."
        />
      </LayoutTable>
    </>
  );
}
